import {
  createContext,
  type PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
} from "react";

type PermissionsHelpContextValue = {
  openWithRoute: (route?: string) => void;
};

const PermissionsHelpContext = createContext<
  PermissionsHelpContextValue | undefined
>(undefined);

const noopPermissionsHelp: PermissionsHelpContextValue = {
  openWithRoute: () => {},
};

export const usePermissionsHelp = (): PermissionsHelpContextValue => {
  const value = useContext(PermissionsHelpContext);

  return value ?? noopPermissionsHelp;
};

type PermissionsHelpProviderProps = PropsWithChildren<{
  onOpenWithRoute: (route?: string) => void;
}>;

export const PermissionsHelpProvider = ({
  children,
  onOpenWithRoute,
}: PermissionsHelpProviderProps) => {
  const openWithRoute = useCallback(
    (route?: string) => {
      onOpenWithRoute(route);
    },
    [onOpenWithRoute],
  );

  const contextValue = useMemo(() => ({ openWithRoute }), [openWithRoute]);

  return (
    <PermissionsHelpContext.Provider value={contextValue}>
      {children}
    </PermissionsHelpContext.Provider>
  );
};
